import { render, staticRenderFns } from "./LogicalNumberRegister.vue?vue&type=template&id=641a5d7a"
import script from "./LogicalNumberRegister.vue?vue&type=script&lang=js"
export * from "./LogicalNumberRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports